import API from '@aws-amplify/api'
import { apiName } from '../config'
import { overrideAPIDomain } from '../utils'

class Http {
  get = (api, queryStringParameters = {}, headers = {}, apiConfig = 'oldAPIDomain') => {
    overrideAPIDomain(apiConfig)
    return API.get(apiName, api, { headers, queryStringParameters })
  }

  post = (api, body = {}, headers = {}, apiConfig = 'oldAPIDomain') => {
    overrideAPIDomain(apiConfig)
    return API.post(apiName, api, { headers, body })
  }

  tracking = (api, body = {}, headers = {}) => API.post('es', api, { headers, body })

  PatientRR = (api, queryStringParameters = {}, headers = {}) =>
    API.get('rr', api, { headers, queryStringParameters })

  put = (api, body = {}, headers = {}, apiConfig = 'oldAPIDomain') => {
    overrideAPIDomain(apiConfig)
    return API.put(apiName, api, { headers, body })
  }

  delete = (api, body = {}, headers = {}, apiConfig = 'oldAPIDomain') => {
    overrideAPIDomain(apiConfig)
    return API.del(apiName, api, { headers, body })
  }
}

export default new Http()
